import { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFetchCycle, useCycle } from '../../redux/slices/practices'
import { formatCycleRange } from '../../lib/cycles'

export default function CycleLabel({ cycleId}) {
  const fetchCycle = useFetchCycle(cycleId)
  const cycle = useCycle(cycleId)
  const cycleLabel = useMemo(() => formatCycleRange(cycle), [cycle])

  useEffect(() => {
    if (cycleId) {
      fetchCycle()
    }
  }, [cycleId, fetchCycle])

  if (!cycle) {
    return null
  }

  return <span>Cycle: {cycleLabel}</span>
}

CycleLabel.propTypes = {
  cycleId: PropTypes.string.isRequired,
}
